import React from "react";

import { useTrackLead } from "web/react/hooks/use-track-lead/use-track-lead";
import { TrackLeadPage } from "web/types/serializers";
import * as styles from "./styles.css";

export function CssRedirectPage(props: TrackLeadPage): React.ReactElement {
    useTrackLead(props);

    return (
        <div className={styles.container}>
            <div className={styles.redirectInterstitial}></div>
        </div>
    );
}
